module.exports = __webpack_public_path__ + "img/colaborador.56873999.png";